/* tslint:disable */

declare var Object: any;
export interface TrayInterface {
  "name"?: string;
  "displayName"?: string;
  "order"?: number;
  "active"?: boolean;
  "ownerUserAccountId": number;
  "public"?: boolean;
  "createdAt"?: Date;
  "createdBy"?: number;
  "updatedAt"?: Date;
  "updatedBy"?: number;
  "id"?: number;
}

export class Tray implements TrayInterface {
  "name": string;
  "displayName": string;
  "order": number;
  "active": boolean;
  "ownerUserAccountId": number;
  "public": boolean;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "id": number;
  constructor(data?: TrayInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Tray`.
   */
  public static getModelName() {
    return "Tray";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Tray for dynamic purposes.
  **/
  public static factory(data: TrayInterface): Tray{
    return new Tray(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Tray',
      plural: 'Trays',
      path: 'Trays',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "displayName": {
          name: 'displayName',
          type: 'string'
        },
        "order": {
          name: 'order',
          type: 'number'
        },
        "active": {
          name: 'active',
          type: 'boolean'
        },
        "ownerUserAccountId": {
          name: 'ownerUserAccountId',
          type: 'number'
        },
        "public": {
          name: 'public',
          type: 'boolean',
          default: true
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
